import { clsx, type ClassValue } from "clsx";
export function cn(...v: ClassValue[]): string {
  return clsx(v);
}
